import React from 'react'

class DebouncedLoader extends React.Component {
  constructor(props) {
    super(props)
    this.state = { visible: false }
    this.timerRef = null
  }

  componentDidUpdate(prevProps) {
    const { loading, delayMs = 350 } = this.props

    if (loading && !prevProps.loading) {
      if (this.timerRef) clearTimeout(this.timerRef)

      this.timerRef = setTimeout(() => {
        this.setState({ visible: true })
        this.timerRef = null
      }, delayMs)
    }

    if (!loading && prevProps.loading) {
      if (this.timerRef) {
        clearTimeout(this.timerRef)
        this.timerRef = null
      }
      this.setState({ visible: false })
    }
  }

  componentWillUnmount() {
    if (this.timerRef) clearTimeout(this.timerRef)
  }

  render() {
    if (!this.state.visible) return null

    return (
        <div className="my-load" id="loading">
            <div className="loader-demo-box">
                <div className="bar-loader">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
        </div>
    );
  }
}

export default DebouncedLoader
